module.exports = __webpack_public_path__ + "static/media/test-screen.f14721a5.png";